<template>
  <div class="py-4 lg:py-6 xl:py-8 px-2 md:px-4 max-w-7xl mx-auto" :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">
    <div class="banner mb-4 md:mb-8" v-if="$route.name === 'topicList'">
      <img src="~@/assets/images/banner/article.webp" class="w-full h-full object-cover hidden md:block">
      <img src="~@/assets/images/banner/article_mobile.webp" class="w-full h-full object-cover md:hidden">
    </div>
    <div class="flex flex-wrap">
      <div class="w-full lg:w-3/4 lg:pl-0 lg:pr-8 order-2 lg:order-1">
        <router-view></router-view>
      </div>
      <div class="w-full lg:w-1/4 order-1 lg:order-2">
        <SideBar />
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/article/SideBar'
export default {
  name: 'Topic',
  metaInfo () {
    return {
      title: '主題專欄',
      titleTemplate: null
    }
  },
  data () {
    return {
    }
  },
  components: {
    SideBar
  },
  computed: {
  },
  mounted () {
  },
  updated () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
